// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--3gX03";
export var contactItem = "Footer-module--contactItem--12icr";
export var contactIcon = "Footer-module--contactIcon--3RW45";
export var socialIcon = "Footer-module--socialIcon--1PI86";